export const Icons = ({ className = '', variant, onClick = () => {}, color = '' }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.EVERYONE: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7.9987" cy="8.00065" r="5.66667" stroke="#AAABAB" strokeWidth="2" />
            <path
              d="M7.33333 11C7.06667 10.7333 7 9.33331 7 8.66664C5.33333 8 3.94323 6.55317 3 4.66666C4.46856 1.72954 7.70208 1.70984 10.3333 2.66666C10.3833 2.68483 9.93333 4.13331 9.66667 4.66664C9.33333 5.33331 9 5.66666 8.33333 5.99999C7.66667 6.33332 6.66667 6.33331 7 7.33331C7.33333 8.33331 8.66667 7.99999 9.66667 8.33332C10.4667 8.59999 10.6667 9.2222 10.3333 9.66664C11.3333 9.66664 12.4 10.0667 12.6667 10.3333C13 10.6667 12 12.3333 11.6667 12.6666C11.4 12.9333 9.44444 13.7778 8.66667 14C8.17354 13.0137 8.16685 11.8335 7.33333 11Z"
              fill="#AAABAB"
            />
          </svg>
        );
      }
      case Icons.USER: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5 6.5C13.5 8.433 11.933 10 10 10C8.067 10 6.5 8.433 6.5 6.5C6.5 4.567 8.067 3 10 3C11.933 3 13.5 4.567 13.5 6.5Z"
              stroke="#AAABAB"
              strokeWidth="2"
            />
            <path
              d="M4.75 16.5625C5.0772 14.9265 6.58151 13.5 8.24989 13.5H11.75C13.4184 13.5 14.9228 14.9265 15.25 16.5625"
              stroke="#AAABAB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.PDF_LINK: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 10C10 4.47715 14.4772 0 20 0H44.4396C46.0752 0 47.6399 0.667701 48.7715 1.84857L68.3319 22.2594C69.4024 23.3764 70 24.8637 70 26.4108V70C70 75.5229 65.5228 80 60 80H20C14.4772 80 10 75.5229 10 70V10Z"
              fill="#FF576D"
            />
            <path
              opacity="0.2"
              d="M45 0.0283203C46.4289 0.162354 47.7699 0.803486 48.7715 1.84863L68.332 22.2598C69.0709 23.0308 69.5848 23.9782 69.832 25H51C47.6863 25 45 22.3137 45 19V0.0283203Z"
              fill="white"
            />
            <path
              d="M21.5131 58V43.4545H27.5216C28.6107 43.4545 29.5505 43.6676 30.3412 44.0938C31.1367 44.5152 31.7499 45.1046 32.1807 45.8622C32.6116 46.6151 32.827 47.491 32.827 48.4901C32.827 49.4938 32.6069 50.3722 32.1665 51.125C31.7309 51.8731 31.1083 52.4531 30.2986 52.8651C29.489 53.277 28.5278 53.483 27.4151 53.483H23.7077V50.7131H26.7617C27.292 50.7131 27.7347 50.6207 28.0898 50.4361C28.4497 50.2514 28.7219 49.9934 28.9066 49.6619C29.0912 49.3258 29.1836 48.9351 29.1836 48.4901C29.1836 48.0402 29.0912 47.652 28.9066 47.3253C28.7219 46.9938 28.4497 46.7382 28.0898 46.5582C27.73 46.3783 27.2873 46.2884 26.7617 46.2884H25.0287V58H21.5131ZM39.8464 58H34.47V43.4545H39.8393C41.3213 43.4545 42.5974 43.7457 43.6674 44.3281C44.7422 44.9058 45.5708 45.7391 46.1532 46.8281C46.7356 47.9124 47.0268 49.2098 47.0268 50.7202C47.0268 52.2353 46.7356 53.5374 46.1532 54.6264C45.5756 55.7154 44.7493 56.5511 43.6745 57.1335C42.5997 57.7112 41.3237 58 39.8464 58ZM37.9856 55.0028H39.7115C40.5259 55.0028 41.2148 54.8655 41.7782 54.5909C42.3464 54.3116 42.7749 53.8594 43.0637 53.2344C43.3573 52.6046 43.5041 51.7666 43.5041 50.7202C43.5041 49.6738 43.3573 48.8404 43.0637 48.2202C42.7702 47.5952 42.3369 47.1454 41.764 46.8707C41.1958 46.5914 40.4951 46.4517 39.6618 46.4517H37.9856V55.0028ZM48.9894 58V43.4545H58.9183V46.3097H52.505V49.2926H58.2862V52.1548H52.505V58H48.9894Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.GOOGLE_SHEET_LINK: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 10C10 4.47715 14.4772 0 20 0H44.4396C46.0752 0 47.6399 0.667701 48.7715 1.84857L68.3319 22.2594C69.4024 23.3764 70 24.8637 70 26.4108V70C70 75.5229 65.5228 80 60 80H20C14.4772 80 10 75.5229 10 70V10Z"
              fill="#04A451"
            />
            <path
              opacity="0.2"
              d="M45 0.0273438C46.4289 0.161378 47.7699 0.802509 48.7715 1.84766L68.332 22.2588C69.0709 23.0299 69.5848 23.9772 69.832 24.999H51C47.6863 24.999 45 22.3127 45 18.999V0.0273438Z"
              fill="white"
            />
            <rect x="22" y="42" width="4" height="22" fill="white" />
            <rect x="58" y="50" width="4" height="36" transform="rotate(90 58 50)" fill="white" />
            <rect x="58" y="60" width="4" height="36" transform="rotate(90 58 60)" fill="white" />
            <rect x="58" y="40" width="4" height="36" transform="rotate(90 58 40)" fill="white" />
            <rect x="54" y="42" width="4" height="22" fill="white" />
            <rect x="38" y="42" width="4" height="22" fill="white" />
          </svg>
        );
      }
      case Icons.DOC_LINK: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 10C10 4.47715 14.4772 0 20 0H44.4396C46.0752 0 47.6399 0.667701 48.7715 1.84857L68.3319 22.2594C69.4024 23.3764 70 24.8637 70 26.4108V70C70 75.5229 65.5228 80 60 80H20C14.4772 80 10 75.5229 10 70V10Z"
              fill="#4673D1"
            />
            <path
              opacity="0.2"
              d="M45 0.0273438C46.4289 0.161378 47.7699 0.802509 48.7715 1.84766L68.332 22.2588C69.0709 23.0299 69.5848 23.9772 69.832 24.999H51C47.6863 24.999 45 22.3127 45 18.999V0.0273438Z"
              fill="white"
            />
            <rect x="58" y="50" width="4" height="36" transform="rotate(90 58 50)" fill="white" />
            <rect x="43" y="60" width="4" height="21" transform="rotate(90 43 60)" fill="white" />
            <rect x="58" y="40" width="4" height="36" transform="rotate(90 58 40)" fill="white" />
          </svg>
        );
      }
      case Icons.UNKNOWN_LINK: {
        return (
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_80338_57096)">
              <path
                d="M26.6689 37.3366C27.538 38.2236 28.5752 38.9282 29.72 39.4092C30.8647 39.8902 32.0939 40.138 33.3356 40.138C34.5773 40.138 35.8065 39.8902 36.9513 39.4092C38.096 38.9282 39.1333 38.2236 40.0023 37.3366L50.6689 26.67C52.4371 24.9018 53.4304 22.5038 53.4304 20.0033C53.4304 17.5028 52.4371 15.1047 50.6689 13.3366C48.9008 11.5685 46.5028 10.5752 44.0023 10.5752C41.5018 10.5752 39.1037 11.5685 37.3356 13.3366L36.0023 14.67"
                stroke={color || '#928CDA'}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M37.3332 26.6637C36.4642 25.7767 35.4269 25.0721 34.2822 24.5911C33.1375 24.1101 31.9082 23.8623 30.6665 23.8623C29.4248 23.8623 28.1956 24.1101 27.0509 24.5911C25.9061 25.0721 24.8689 25.7767 23.9999 26.6637L13.3332 37.3303C11.5651 39.0984 10.5718 41.4965 10.5718 43.997C10.5718 46.4975 11.5651 48.8956 13.3332 50.6637C15.1013 52.4318 17.4994 53.4251 19.9999 53.4251C22.5004 53.4251 24.8984 52.4318 26.6665 50.6637L27.9999 49.3303"
                stroke={color || '#928CDA'}
                strokeWidth="6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_80338_57096">
                <rect width="64" height="64" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.ZILLOW: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50.62 23.8278C50.9251 23.7478 51.0644 23.8633 51.2451 24.0766C52.2821 25.3091 55.6241 29.6052 56.5336 30.7814C56.5668 30.823 56.5911 30.871 56.6051 30.9224C56.6191 30.9737 56.6224 31.0274 56.6149 31.0801C56.6074 31.1328 56.5893 31.1834 56.5615 31.2288C56.5338 31.2743 56.4971 31.3136 56.4536 31.3443C49.7164 36.8936 42.2206 44.742 38.0432 50.3653C37.9543 50.4839 38.0283 50.4927 38.0876 50.4661C45.3641 47.1596 62.4532 41.8829 70.1622 40.4045V30.1118L40.0312 4.97266L9.83789 30.1118V41.3615C19.1972 35.4922 40.8222 26.4054 50.62 23.8278ZM25.4545 66.9598C25.6174 67.1613 25.8989 67.2028 26.1063 67.0606C37.2995 60.975 61.9228 53.2511 70.1622 51.7727V74.9001H9.84085V50.872C16.0419 47.1685 32.7932 39.5719 38.689 37.5395C38.8075 37.498 38.8342 37.5691 38.7335 37.6491C33.0746 42.0844 24.2042 52.5519 19.8579 59.2803C19.6594 59.5944 19.6712 59.6951 19.8282 59.8877L25.4545 66.9598Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.REDFIN: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M76 42.9641C76.0014 49.1862 74.3871 55.302 71.3152 60.7128C68.2433 66.1237 63.819 70.6442 58.4754 73.8318C58.2801 73.9465 58.0515 73.9915 57.8273 73.9594C57.603 73.9273 57.3963 73.82 57.2411 73.655L45.1597 60.8087C45.0452 60.6874 44.9629 60.5393 44.9204 60.3779C44.8779 60.2166 44.8767 60.0471 44.9167 59.8851C44.9567 59.7232 45.0368 59.5738 45.1496 59.4508C45.2623 59.3278 45.4041 59.2351 45.562 59.1812C48.9435 58.0232 51.8786 55.8378 53.9572 52.9302C56.0359 50.0226 57.1541 46.5382 57.1557 42.9641C57.1549 40.6871 56.7006 38.4331 55.8194 36.3335C54.9382 34.234 53.6477 32.3309 52.0232 30.7354C50.3987 29.1398 48.4728 27.8838 46.3577 27.0405C44.2427 26.1971 41.9809 25.7834 39.7043 25.8235C30.2958 25.9789 22.838 33.8452 22.838 43.2445V72.8565C22.8375 73.0348 22.7895 73.2098 22.6989 73.3634C22.6082 73.5171 22.4783 73.6437 22.3224 73.7304C22.1665 73.817 21.9903 73.8605 21.812 73.8563C21.6337 73.8522 21.4597 73.8006 21.308 73.7068C16.0885 70.5442 11.7607 66.1041 8.73298 60.8053C5.70523 55.5065 4.07732 49.5236 4.00282 43.4212C3.75596 23.6779 19.7232 7.28093 39.4879 7.00358C59.6031 6.72319 76 22.9281 76 42.9641Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.HOMES: {
        return (
          <svg
            width="81"
            height="81"
            viewBox="0 0 81 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.8026 21.8294L38.424 28.0694C38.8768 28.1907 39.4588 27.9912 39.7299 27.6179L47.9982 16.2804C48.2663 15.8927 48.1704 15.3629 47.782 15.0945L36.0721 7.24458C35.6885 6.98845 35.0738 7.00147 34.6955 7.2724L15.6693 21.0816C15.293 21.3619 15.3555 21.699 15.8026 21.8294Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M34.6955 7.2724C35.0738 7.00147 35.6885 6.98845 36.0721 7.24458L47.782 15.0945C48.1704 15.3629 48.2663 15.8927 47.9982 16.2804L39.7299 27.6179C39.4588 27.9912 38.8768 28.1907 38.424 28.0694L15.8026 21.8294C15.3555 21.699 15.293 21.3619 15.6693 21.0816L34.6955 7.2724Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M52.6977 11.5045L53.7531 34.9433C53.7682 35.4085 54.1435 35.8966 54.5804 36.0436L67.9276 40.3999C68.3775 40.5331 68.8496 40.2759 68.9874 39.8337L72.8361 26.268C72.9591 25.8256 72.7577 25.239 72.3815 24.9681L53.3676 11.1454C52.9849 10.8742 52.6841 11.0352 52.6977 11.5045Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M52.6977 11.5045L53.7531 34.9433C53.7682 35.4085 54.1435 35.8966 54.5804 36.0436L67.9276 40.3999C68.3775 40.5331 68.8496 40.2759 68.9874 39.8337L72.8361 26.268C72.9591 25.8256 72.7577 25.239 72.3815 24.9681L53.3676 11.1454C52.9849 10.8742 52.6841 11.0352 52.6977 11.5045Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M73.9128 43.3813L51.9386 51.6295C51.5054 51.7899 51.1523 52.2972 51.1523 52.7583L51.1348 66.791C51.1452 67.2592 51.5306 67.6345 52.001 67.6215L66.0905 67.0887C66.5526 67.0713 67.0435 66.6986 67.1869 66.2591L74.4621 43.9114C74.5999 43.4606 74.3505 43.2224 73.9128 43.3813Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M73.9128 43.3813L51.9386 51.6295C51.5054 51.7899 51.1523 52.2972 51.1523 52.7583L51.1348 66.791C51.1452 67.2592 51.5306 67.6345 52.001 67.6215L66.0905 67.0887C66.5526 67.0713 67.0435 66.6986 67.1869 66.2591L74.4621 43.9114C74.5999 43.4606 74.3505 43.2224 73.9128 43.3813Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50.1415 73.425L35.5097 55.0805C35.2237 54.7182 34.6286 54.5347 34.1906 54.6774L20.8351 58.9925C20.3899 59.1488 20.1563 59.6303 20.3118 60.0784L25.1673 73.3114C25.3312 73.7417 25.8378 74.0945 26.3007 74.0945L49.8107 74.1087C50.2784 74.101 50.4301 73.7977 50.1415 73.425Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M50.1415 73.425L35.5097 55.0805C35.2237 54.7182 34.6286 54.5347 34.1906 54.6774L20.8351 58.9925C20.3899 59.1488 20.1563 59.6303 20.3118 60.0784L25.1673 73.3114C25.3312 73.7417 25.8378 74.0945 26.3007 74.0945L49.8107 74.1087C50.2784 74.101 50.4301 73.7977 50.1415 73.425Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.4851 60.001L6.2313 37.6397C6.08588 37.1966 6.26485 36.6053 6.62526 36.3232L17.715 27.6101C18.0892 27.3262 18.6209 27.4014 18.906 27.7704L27.1398 39.139C27.4101 39.5104 27.4219 40.1299 27.163 40.5143L14.2359 60.0978C13.9715 60.4879 13.6351 60.4414 13.4851 60.001Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.906 27.7704L27.1398 39.139C27.4101 39.5104 27.4219 40.1299 27.163 40.5143L14.2359 60.0978C13.9715 60.4879 13.6351 60.4414 13.4851 60.001L6.2313 37.6397C6.08588 37.1966 6.26485 36.6053 6.62526 36.3232L17.715 27.6101C18.0892 27.3262 18.6209 27.4014 18.906 27.7704Z"
              fill="white"
            />
          </svg>
        );
      }
      case Icons.DROPBOX: {
        return (
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.4818 10.7695L5.14844 21.7928L22.4818 32.816L39.8181 21.7928L57.1516 32.816L74.4849 21.7928L57.1516 10.7695L39.8181 21.7928L22.4818 10.7695Z"
              fill="#F7F5F2"
            />
            <path
              d="M22.4818 54.8613L5.14844 43.8378L22.4818 32.8145L39.8181 43.8378L22.4818 54.8613Z"
              fill="#F7F5F2"
            />
            <path
              d="M39.8184 43.8378L57.1519 32.8145L74.4852 43.8378L57.1519 54.8613L39.8184 43.8378Z"
              fill="#F7F5F2"
            />
            <path
              d="M39.8177 69.5601L22.4814 58.5369L39.8177 47.5137L57.1512 58.5369L39.8177 69.5601Z"
              fill="#F7F5F2"
            />
          </svg>
        );
      }
      case Icons.REALTOR: {
        return (
          <svg
            width="81"
            height="81"
            viewBox="0 0 81 81"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_83957_120558)">
              <path
                d="M80.4766 42.6113H68.2949V79.4102H12.7051V42.6348H0.5L40.5234 1.62109L80.4766 42.6113ZM51.001 30.2676C47.6622 30.2676 45.5435 31.6493 44.0928 32.8467L44.0703 32.8701C42.0301 34.7977 40.4884 37.1923 39.5791 39.8477L39.6719 36.0938L39.7402 32.0635C39.7401 31.603 39.4173 31.1426 38.7266 31.1426H25.7393V32.248L26.084 32.2705C27.1433 32.3626 28.157 32.4552 29.0781 33.123C29.884 33.6757 30.3681 34.4357 30.5293 35.4258C30.8055 36.5315 30.8057 39.8467 30.8057 41.2744V60.0889C30.8057 62.0232 30.7366 64.6483 30.46 66.3984C29.9304 68.1255 29.3773 68.6548 28.249 69.2305C27.5091 69.5485 26.7243 69.7513 25.9229 69.8301L25.5547 69.8525V70.958H44.9678V69.8525L44.6221 69.8301C43.8391 69.7613 43.24 69.6452 42.457 69.2998C41.8816 69.0925 41.3752 68.5626 40.8457 67.5957C40.0858 65.9607 39.6016 64.1186 39.6016 59.6514V51.8213C39.6016 49.4266 39.717 47.1471 39.7861 46.1338C40.6612 39.8701 44.0696 34.8496 46.2803 34.8496C47.1323 34.8497 47.6615 35.7714 48.2832 37.2451C48.974 38.9261 49.9882 40.7217 52.8896 40.7217C55.7217 40.7215 57.2186 38.3273 57.2188 35.9326C57.2414 34.3206 56.7578 32.9843 55.7676 31.8789V31.8799C54.4496 30.7417 52.7392 30.1628 51.001 30.2676Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_83957_120558">
                <rect width="80" height="80" fill="white" transform="translate(0.5 0.5)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      default:
        return null;
    }
  };
  return (
    <div style={{ display: 'flex' }} onClick={onClick} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.EVERYONE = 'everyone';
Icons.USER = 'user';
Icons.PDF_LINK = 'pdfLink';
Icons.GOOGLE_SHEET_LINK = 'googleSheetLink';
Icons.DOC_LINK = 'docLink';
Icons.UNKNOWN_LINK = 'unknownLink';
Icons.ZILLOW = 'zillow';
Icons.REDFIN = 'redfin';
Icons.HOMES = 'homes';
Icons.DROPBOX = 'dropbox';
Icons.REALTOR = 'realtor';
